(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mx-style"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',e=>document.querySelectorAll('.mx-dropdown[open]').forEach(d=>{if(!d.contains(e.target))d.open=false}));document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.mx-dropdown[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});
if(!customElements.get('mx-product-tabs'))customElements.define('mx-product-tabs',class extends HTMLElement{
 connectedCallback(){if(this.initialized)return;this.initialized=true;this.tabs=Array.from(this.querySelectorAll('[role=tab]'));this.panels=Array.from(this.querySelectorAll('[role=tabpanel]'));this.activate(0);this.tabs.forEach((t,i)=>{t.addEventListener('click',()=>this.activate(i));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();this.activate(n);this.tabs[n].focus()})});this.addEventListener('shopify:block:select',e=>{let i=this.panels.findIndex(p=>p===e.target||p.contains(e.target));if(i>=0)this.activate(i)})}
 activate(i){this.tabs.forEach((t,n)=>{t.setAttribute('aria-selected',n===i?'true':'false');t.tabIndex=n===i?0:-1});this.panels.forEach((p,n)=>p.hidden=n!==i)}
});
  } catch(e) { console.error(e); }
})();

})();
